import styled, { css } from 'styled-components';
import { BORDER_DEFAULT, TEXT_MUTED, TEXT_PRIMARY } from '../consts';

export const TooltipCard = styled.div`
  ${({ theme: { colors, spacings } }) => css`
    padding: ${spacings.s8} ${spacings.s12};
    background: #fff;
    border: 1px solid ${BORDER_DEFAULT};
    border-radius: 8px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
    color: ${colors.brandDarkTint20};
    font-size: 0.857rem;
  `};
`;

export const TooltipLabel = styled.p`
  margin: 0 0 6px;
`;

export const TooltipRow = styled.div`
  display: flex;
  align-items: center;
  line-height: 1.25rem;
`;

export const SeriesDot = styled.span<{ $color: string }>`
  width: 8px;
  height: 8px;
  border-radius: 9999px;
  flex-shrink: 0;
  background-color: ${({ $color }) => $color};
  margin-right: 6px;
`;

export const SeriesName = styled.span`
  ${({ theme: { colors, spacings } }) => css`
    color: ${colors.brandDarkTint30};
    margin-right: ${spacings.s8};
  `};
`;

export const SeriesValue = styled.span`
  margin-left: auto;
  padding-left: 20px;
  font-weight: 600;
  color: ${TEXT_PRIMARY};
`;

export const PointTitle = styled.p`
  margin: 0 0 2px;
  text-transform: capitalize;
`;

export const PointSubtitle = styled.p`
  margin: 0;
  color: ${TEXT_PRIMARY};
  font-weight: 600;
`;

export const PointSubtitleLabel = styled.span`
  color: ${TEXT_MUTED};
  font-weight: 400;
`;
